import axios from "axios";
import { store } from "@/store/store";
// import { config } from "@/config/config";

export default () => {
  return axios.create({
    baseURL:
      process.env.NODE_ENV === "production"
        ? `${process.env.VUE_APP_URL}`
        : `${process.env.VUE_APP_URL}:${process.env.VUE_APP_PORT}`,
    headers: {
      Authorization: `Bearer ${store.state.token}`,
    },
  });
};
